import request from '@/utils/request'

export function attendItems (params) {
  return request({
    url: '/amrep/attend/items',
    method: 'get',
    params
  })
}

export function attendMonthItems (params) {
  return request({
    url: '/amrep/attend/monthItems',
    method: 'get',
    params
  })
}

export function attendMyItems (params) {
  return request({
    url: '/amrep/attend/myItems',
    method: 'get',
    params
  })
}

export function attendIndexPage () {
  return request({
    url: '/amrep/attend/indexPage',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/attend.js